import { AdOverviewFilters } from './widgets/ad-overview-filters/AdOverviewFilters'
import { BpTab } from '../../shared/components/utility/tabs/tab/BpTab'
import { BpTabs } from '../../shared/components/utility/tabs/BpTabs'
import { useAppDispatch, useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectAdOverviewActiveTab,
  selectOnlyShoppingAds,
  selectProject,
  setAdOverviewActiveTab,
  setOnlyShoppingAds,
  TAdOverviewTabs,
} from './model/adOverviewSlice'
import { AdsTable } from './widgets/ads-table/AdsTable'
import { AdsPanel } from './widgets/ads-panel/AdsPanel'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { selectPreviousLocation } from '../../app/store/reducers/AppSlice'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import { ShoppingAdsTable } from './widgets/shopping-ads-table/ShoppingAdsTable'
import { ShoppingAdsPanel } from './widgets/shopping-ads-panel/ShoppingAdsPanel'
import { useEffect } from 'react'
import clsx from 'clsx'

import styles from './AdOverviewPage.module.scss'

export const AdOverviewPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const previousLocation = useAppSelector(selectPreviousLocation)
  const activeTab = useAppSelector(selectAdOverviewActiveTab)
  const onlyShoppingAds = useAppSelector(selectOnlyShoppingAds)
  const { has_paid_links: hasPaidLinks, has_shopping_ads: hasShoppingAds } =
    useAppSelector(selectProject)

  useEffect(() => {
    if (onlyShoppingAds) {
      dispatch(setAdOverviewActiveTab(t('pages.adOverview.shoppingAds') as TAdOverviewTabs))
      dispatch(setOnlyShoppingAds(false))
    }
  }, [])

  return (
    <>
      <AdOverviewFilters />
      {hasPaidLinks ? (
        <BpTabs
          back={() => {
            navigate(
              previousLocation
                ? previousLocation.pathname + previousLocation.search
                : '/ad-reports',
            )
          }}
          active={activeTab}
          className={clsx(styles.tabs)}
          size={'md'}
          onToggle={(e) => dispatch(setAdOverviewActiveTab(e as TAdOverviewTabs))}
        >
          <BpTab panel={<AdsPanel />} title={t('pages.adOverview.ads')}>
            <section className={clsx(styles.tabPanel)}>
              <AdsTable />
            </section>
          </BpTab>
          <BpTab
            hide={!hasShoppingAds}
            panel={<ShoppingAdsPanel />}
            title={t('pages.adOverview.shoppingAds')}
          >
            <section className={clsx(styles.tabPanel)}>
              <ShoppingAdsTable />
            </section>
          </BpTab>
        </BpTabs>
      ) : (
        // над заглушкой пустая строка чипов фильтров (8px)
        <StubLayout gap={8}>
          <PreparingDataStub />
        </StubLayout>
      )}
    </>
  )
}
